var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canView && _vm.selectedReport && _vm.selectedReport.id)?_c('div',{staticClass:"view"},[_c('ReportGridView',{attrs:{"templateData":_vm.selectedReport,"showModule":true},on:{"hideReportGridView":_vm.hideReportGridView}})],1):_c('div',[_c('forbidden')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }